import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StrategicBusinessDriversComponent } from './strategic-business-drivers.component';

const routes: Routes = [
  {
    path: '',
    component: StrategicBusinessDriversComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StrategicBusinessDriversRoutingModule { }
